<template>
</template>
<script>
import { Dialog } from 'vant';
import { Toast } from 'vant';
import { wxRequest } from '@/api/user.js'
export default {
    data() {
        return {
        }
    },
    created() {
        if (this.$route.query.id) {
            var data = {
                id: this.$route.query.id
            }
            wxRequest("sim/select/scan", data, "post").then(res => {
                if (res.data.code == 200) {
                    window.location.href=res.data.data;
                }else{
                    Dialog.alert({ title: '提示', message: res.data.message });
                }
            })
        } else {
            Dialog.alert({ title: '提示', message: '参数缺失！请联系客服处理！' });
        }
    },

}
</script>
<style lang="less" scoped>
div {
    display: flex;
    flex-grow: 0;
    flex-basis: auto;
    align-items: stretch;
    flex-direction: column;
}

.page {
    height: 100%;
    background: #f7f8fa;

    .top {
        flex-direction: row;
        align-items: center;
        height: 44px;
        background-color: #3bb272;

        .top-back {
            width: 30px;
            align-items: center;
            text-align: center;
            position: absolute;
            height: 44px;
            line-height: 44px;
            justify-content: center;
            color: #fff;
            font-size: 20px;
        }

        .top-name {
            text-align: center;
            font-size: 17px;
            color: #fff;
            flex: 1 1 0%;
        }
    }

    .view-box {
        width: calc(100% - 30px);
        padding: 15px;
        background-color: #fff;
        margin-bottom: 5px;

        .gtr {
            font-size: 22px;
            font-weight: 800;
            color: #06121e;
            padding: 5px 0 15px;
        }

        .text {
            border-top: 1px solid #eee;
            font-size: 16px;
            line-height: 28px;
            font-weight: 400;
            color: #06121e;
            padding: 15px 0;
        }

        .btn {
            align-self: center;
            width: 145px;
            height: 42px;
            background: #3bb272;
            color: #fff;
            line-height: 42px;
            font-size: 16px;
            text-align: center;
            border-radius: 4px;
            margin-bottom: 20px;
        }
    }

    .uni-list-item {
        font-size: 16px;
        position: relative;
        justify-content: space-between;
        align-items: center;
        background-color: #fff;
        flex-direction: row;
        cursor: pointer;
    }

    .left {
        position: relative;
        flex-direction: row;
        padding: 12px 15px;
        padding-left: 15px;
        flex: 1;
        overflow: hidden;
    }

    .right {
        color: #bbbbbb;
        font-size: 16px;
        padding: 0 10px;
    }
}
</style>
